'use client';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import {publishEvent} from '@udemy-v2/event-tracking';
import {usePageContext} from '../../context/page-context';

import {LandingPageCTASelected} from '../events';

import styles from './solutions-section.module.scss';

interface SolutionsContentProps {
    heading: string;
    description: string;
    image: string;
    cta: string;
    url: string;
    selected: boolean;
}

const SolutionsContent: React.FC<SolutionsContentProps> = ({
    heading,
    description,
    image,
    cta,
    url,
    selected,
}) => {
    const {pageFor} = usePageContext();

    const handleClick = () => {
        publishEvent(new LandingPageCTASelected({componentName: cta, pageFor}));
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <section className={`${styles.bannerSection} ${selected ? styles.selected : ''}`}>
            <Image
                src={image}
                alt="Learning solution background"
                className={styles.bannerImage}
                width={100}
                height={100}
            />
            <div className={styles.contentCard}>
                <h2 className={styles.cardHeading}>{heading}</h2>
                <p className={styles.cardDescription}>{description}</p>
                <Link
                    href={url}
                    className={styles.ctaLink}
                    onClick={handleClick}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className={styles.ctaText}>{cta} </span>
                    <Image
                        src="/indeed/learning/arrow-right.svg"
                        alt="Arrow right"
                        className={styles.ctaIcon}
                        width={12}
                        height={12}
                    />
                </Link>
            </div>
        </section>
    );
};

export {SolutionsContent};
